// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 3H1V21H23V3ZM4.99609 7.5H7V9.50391H4.99609V7.5ZM19 15V17H5V15H19ZM11 7.5V9.50391H8.99609V7.5H11ZM12.9961 7.5H15V9.50391H12.9961V7.5ZM19 7.5V9.50391H16.9961V7.5H19ZM4.99609 10.5H7V12.5039H4.99609V10.5ZM11 10.5V12.5039H8.99609V10.5H11ZM12.9961 10.5H15V12.5039H12.9961V10.5ZM19 10.5V12.5039H16.9961V10.5H19Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-keyboard-filled')
export default class KeyboardFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'keyboard-filled',
    }
  }
}
